import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import '../../../../../styles/detail-inspection-header.css';
import CustomDate from '../../../../../lib/common/custom-date';
import InspectionTransform from '../../../../../lib/utils/transforms/inspections';
import {
    INSPECTION_STATES_AUX,
    INSPECTION_STATE_CODE
} from '../../../../../constants/app/inspection';

class InspectionHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {newVehiclePlate: ''};
        this.handleChange = this.handleChange.bind(this);
    }

    goBack = () => {
        window.history.back();
    };

    handleChange(event) {
        this.setState({newVehiclePlate: event.target.value.toUpperCase()});
    }

    render() {
        let date = '';
        let fullName;
        const {
            policy = {},
            customer = {names: '', firstSurname: ''},
            inspection,
            state = {},
            disabled,
            enabledObservation,
            reasonsReject = [],
            reasonsDerivations = [],
            isEditMode,
            resolveInspection = () => {
            },
            returnInspection = () => {
            },
            derivationInspection = () => {
            },
            openModalReasons = () => {
            },
            openModalMoreReasonsRejected = () => {
            },
            approveInspection = () => {
            },
            returnToInPersonInspection = () => {
            },
            inPersonToCreateInspection = () => {
            },

            //inPersonToReturn
            inPersonToReturnInspection = () => {
            },

            activeEditMode = () => {
            },
            updateVehiclePlate = () => {
            },
            removeInspections = () => {
            }
        } = this.props;
        const txt = '< VOLVER';
        const lastState = state ? InspectionTransform.getPictureTitle(state.inspectionStatus, INSPECTION_STATES_AUX) : {};
        const icon = lastState && lastState.icon;
        const color = lastState && lastState.color;
        const fullPolicy = (policy && policy.offer && inspection) ? `${policy.offer} / ${policy.productDesc} ${inspection.policyNumber}` : '';
        date = this.props.inspection.creationDate && CustomDate.getSimpleDateFormatMin(this.props.inspection.creationDate);
        if (customer && customer.names) {
            fullName = customer.firstSurname && customer.lastSurname ? `${customer.names.toLowerCase()} ${customer.firstSurname.toLowerCase()} ${customer.lastSurname.toLowerCase()}` : (customer && customer.firstSurname) ? `${customer.names.toLowerCase()} ${customer.firstSurname.toLowerCase()}` : (customer) ? customer.names.toLowerCase() : '';
        } else {
            fullName = '';
        }
        let aux = false;
        if (lastState) {
            if (lastState.id === 'DERIVE' || lastState.id === 'SENT') {
                aux = true;
            }
        }

        if (inspection.vehiclePlate !== undefined) {
            inspection.vehiclePlate.toUpperCase();
        }

        let updateVehicle = () => {
            this.props.inspection.vehiclePlate = this.state.newVehiclePlate;
            this.props.updateVehiclePlate();
            this.props.activeEditMode();
        };

        return (
            <div className="pt10 pb20">
                <div className="back text-md--white"><a onClick={this.goBack} style={{cursor: 'pointer'}}>{txt}</a>
                </div>
                <div className="insp h1">Inspección - <div className="text-md--white date">{date}</div></div>
                <div className="row pright">
                    <div className="main-detail row">
                        <div className="col-xs-12 col-md-6 left-color">
                            <div className="h3 mb10">CLIENTE</div>
                            <div className="h2 capitalize">{fullName}</div>
                            <div className="text-md--light mb5">{fullPolicy}</div>
                            <div
                                className="text-md--light">{(customer && customer.documentType) ? customer.documentType : ''} {(customer && customer.documentNumber) ? customer.documentNumber : ''}</div>
                        </div>
                        <div className="col-xs-12 col-md-6 right">
                            <div className="h3 mb10">AUTO -
                                <a onClick={activeEditMode} hidden={isEditMode} className="select-edit-inspection-mode">
                                    {'Editar'}</a>
                                <a onClick={updateVehicle} hidden={!isEditMode} className="select-edit-inspection-mode">
                                    {'Guardar'}</a>
                                <a onClick={activeEditMode} hidden={!isEditMode}
                                   className="cancel-edit-inspection-mode">
                                    {'Cancelar'}</a>
                            </div>
                            <div
                                className="h2">{inspection.vehicleBrand} {inspection.vehicleModel} {inspection.vehicleYear}</div>
                            <div className="text-md--light mb5">Placa {inspection.vehiclePlate}</div>
                            <div hidden={!isEditMode} className="text-md--light mb5">
                                Nueva Placa <input className="input-edit-plate" type="text"
                                                   value={this.state.newVehiclePlate.toUpperCase()}
                                                   onChange={this.handleChange} name="plate" maxLength={'6'}/>
                            </div>
                            <div className="text-md--light mb5">Uso {inspection.vehicleUse}</div>
                            <div className="text-md--light">Chasis {inspection.vehicleChasis}</div>
                        </div>
                    </div>
                    <div className="main-state col-sm-5 col-md-5">
                        <div className="days-state">
                            <div className={classNames({[color]: lastState})}>
                                <i className={classNames('icon-24', {[icon]: lastState})}/>{lastState && lastState.label}
                            </div>
                            {
                                (inspection.state && (reasonsDerivations.length > 0 && inspection.state.inspectionStatus !== INSPECTION_STATE_CODE.REJECTED))
                                &&
                                <div className="reasons">
                                    <img src='./images/icn_atencion2.svg'/>
                                    <span
                                        className="text-red">{(reasonsDerivations && reasonsDerivations.length > 0) ? reasonsDerivations[0].label : ''}</span>
                                    {(reasonsDerivations.length > 1) &&
                                    <span className="text-red underLine" onClick={openModalReasons}>Ver más</span>}
                                </div>
                            }
                            {
                                (inspection.rejectReason && inspection.state && (inspection.rejectReason.length > 0 && inspection.state.inspectionStatus === INSPECTION_STATE_CODE.REJECTED))
                                &&
                                <div className="reasons">
                                    <img src='./images/icn_atencion2.svg'/>
                                    <span
                                        className="text-red">{(reasonsReject && reasonsReject.length > 0) ? reasonsReject[0].label : ''}</span>
                                    {(reasonsReject.length > 1) && <span className="text-red underLine"
                                                                         onClick={openModalMoreReasonsRejected}>Ver más</span>}
                                </div>
                            }
                        </div>
                        {
                            ((inspection && inspection.state && inspection.state.inspectionStatus === INSPECTION_STATE_CODE.SENT) || (inspection && inspection.state && inspection.state.inspectionStatus === INSPECTION_STATE_CODE.DERIVE))
                            &&
                            <div className="buttons-state">
                                {
                                    lastState && (lastState.id === INSPECTION_STATE_CODE.SENT) ?
                                        <button type="button" className="btn btn-outline-secondary"
                                                disabled={disabled}
                                                onClick={derivationInspection}>Observar
                                        </button> : null
                                }
                                {
                                    enabledObservation >= 1 ?
                                        <button type="button" className="btn btn-danger"
                                                onClick={returnInspection}>Devolver
                                        </button> : null
                                }
                                {
                                    lastState && (aux && !(enabledObservation >= 1)) ?
                                        <button type="button"
                                                className={(lastState.id === INSPECTION_STATE_CODE.DERIVE) ? 'btn btn-primary buttonResolveDerivation' : 'btn btn-primary'}
                                                disabled={disabled}
                                                onClick={resolveInspection}>Resolver
                                        </button> : null
                                }
                                <button type="button" className="btn btn-danger btn-small-danger"
                                        onClick={removeInspections}>
                                    <span className="icon-remove text-white"/>
                                </button>
                            </div>
                        }
                        {
                            ((inspection && inspection.state && inspection.state.inspectionStatus === INSPECTION_STATE_CODE.RETURN))
                            &&
                            <div className="buttons-state">
                                <button type="button" className="btn btn-outline-secondary"
                                        onClick={approveInspection}>Aprobar
                                </button>
                                <button type="button" className="btn btn-outline-secondary"
                                        onClick={returnToInPersonInspection}>Presencial
                                </button>
                                <button type="button" className="btn btn-danger btn-small-danger"
                                        onClick={removeInspections}>
                                    <span className="icon-remove text-white"/>
                                </button>
                            </div>
                        }
                        {
                            ((inspection && inspection.state && inspection.state.inspectionStatus === INSPECTION_STATE_CODE.PRESENCIAL))
                            &&
                            <div className="buttons-state">
                                <button type="button" className="btn btn-outline-danger"
                                        onClick={inPersonToCreateInspection}>Estado Inicial
                                </button>
                                <button type="button" className="btn btn-block btn-outline-warning"
                                    onClick={inPersonToReturnInspection}>Estado Devuelto
                                </button>
                                <button type="button" className="btn btn-danger btn-small-danger"
                                        onClick={removeInspections}>
                                    <span className="icon-remove text-white"/>
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
};

export default withRouter(InspectionHeader);



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/inspection-header.js